import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const DataSecurity = () => {
  return (
    <>
      <SEO 
        title="Data Security & Privacy - Abacies Logiciels"
        description="Learn about Abacies Logiciels' data security measures, encryption standards, privacy protections, and security practices to safeguard client data and information."
        keywords="data security, information security, data protection, privacy, encryption, security practices, data safeguards"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Data Security
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Data Security page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Data Security. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default DataSecurity;
